import script from "./Address.vue?vue&type=script&lang=ts&setup=true"
export * from "./Address.vue?vue&type=script&lang=ts&setup=true"

import "./Address.vue?vue&type=style&index=0&id=4f1e0296&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1e0296"]])

export default __exports__